import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { AuthService } from "../app/auth.service";
import { Router } from "@angular/router";
import { HeaderAndNavigationService } from "../app/headerandnavigation/headerandnavigation.service";
//import { LoggedUserComponent } from './loggeduser.component';


@Component({
   // selector:'[mft-logout]',
    templateUrl:'./logout.component.html'
})
export class LogoutComponent implements OnInit 
{
    
    
    errorMessage: string;
    public loading = false;
    mftAccessToken: string = "mftAccessToken";
    constructor(
       // private fb: FormBuilder,
        private authService: AuthService,
        public headerAndNavigationService: HeaderAndNavigationService,
        private router: Router,
      
        //private logeusercom: LoggedUserComponent,
    ) { }

    ngOnInit(): void {
     // this.logOut();
    }
    logOut() {
      debugger
      this.headerAndNavigationService.ClearUserData();
      this.authService.logout();
      //this.router.navigate(['/']);
    }

    
}



// WEBPACK FOOTER //
// ./src/app/Logout.component.ts